import React from "react";

export const ChevronDown: React.FC<any> = () => (

	<g stroke="none" strokeWidth="1" fillRule="evenodd">
		<polygon
			fillRule="nonzero"
			transform="translate(13.092684, 8.500000) scale(-1, 1) rotate(90.000000) translate(-13.092684, -8.500000) "
			points="5.07239656 -1.95140481 6.92760344 -4.04859519 21.1129719 8.5 6.92760344 21.0485952 5.07239656 18.9514048 16.887 8.5"
		></polygon>
	</g>
);

export const ChevronUp: React.FC<any> = () => (
	<g id="Page-1" stroke="none" strokeWidth="1" fillRule="evenodd">
		<polygon
			fillRule="nonzero"
			transform="translate(13.092684, 8.500000) scale(-1, 1) rotate(-90.000000) translate(-13.092684, -8.500000) "
			points="5.07239656 -1.95140481 6.92760344 -4.04859519 21.1129719 8.5 6.92760344 21.0485952 5.07239656 18.9514048 16.887 8.5"
		></polygon>
	</g>
);

export const QuestionChevron: React.FC<any> = () => (
	<>
		<defs>
			<linearGradient
				x1="-1.11022302e-14%"
				y1="50%"
				x2="100%"
				y2="50%"
				id="question-cheveron"
			>
				<stop stopColor="#6D83A0" offset="0%"></stop>
				<stop stopColor="#617895" offset="8.14038366%"></stop>
				<stop stopColor="#445F7C" offset="31.5726459%"></stop>
				<stop stopColor="#2F4C6A" offset="54.8954427%"></stop>
				<stop stopColor="#23415F" offset="77.8487921%"></stop>
				<stop stopColor="#1F3E5C" offset="100%"></stop>
			</linearGradient>
		</defs>
		<g
			stroke="none"
			strokeWidth="1"
			fill="none"
			fillRule="evenodd"
			strokeLinecap="round"
		>
			<g
				transform="translate(-818.000000, -2038.000000)"
				fillRule="nonzero"
				stroke="url(#question-cheveron)"
				strokeWidth="3.6"
			>
				<g transform="translate(336.000000, 2025.000000)">
					<g transform="translate(482.000000, 15.000000)">
						<path
							d="M8,-5 L22,7.5 L8,20"
							transform="translate(15.000000, 7.500000) rotate(90.000000) translate(-15.000000, -7.500000) "
						></path>
					</g>
				</g>
			</g>
		</g>
	</>
);

export const ChevronRounded: React.FC<any> = () => (
	<g
		stroke="none"
		strokeWidth="1"
		fill="none"
		fillRule="evenodd"
		strokeLinecap="round"
	>
		<g
			transform="translate(-144.000000, -99.000000)"
			fillRule="nonzero"
			stroke="#374B5A"
			strokeWidth="6"
		>
			<g id="Arrow-Back-Active" transform="translate(148.500000, 102.000000)">
				<path
					d="M0,0 L23.0708008,21.1566162 L0,42.3132324"
					transform="translate(11.535400, 21.156616) scale(-1, 1) translate(-11.535400, -21.156616) "
				></path>
			</g>
		</g>
	</g>
);
export const ChevronLight: React.FC<any> = () => (
	<g stroke="none" strokeWidth="1" fillRule="evenodd">
		<polygon
			fillRule="nonzero"
			transform="translate(16.000000, 10.248151) scale(1, -1) translate(-16.000000, -10.248151) "
			points="0.250162145 18.5114379 16 0.661621637 31.7498379 18.5114379 30.2501621 19.8346811 16 3.68305951 1.74983786 19.8346811"
		></polygon>
	</g>
);
